import classNames from 'classnames'
import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import classes from './StickyZone.module.scss'

export const StickyZone = forwardRef<
  HTMLDivElement,
  { children: ReactNode; hasShopCartSticky?: boolean; stickyItemCount?: number }
>(({ children, hasShopCartSticky = false, stickyItemCount }, ref) => {
  return (
    <footer
      className={classNames('Concorde-Layout-Footer', classes.container, {
        [classes.hasShopCartSticky]: hasShopCartSticky,
        [classes.noBackground]: hasShopCartSticky && stickyItemCount === 1
      })}
      ref={ref}
    >
      {children}
    </footer>
  )
})

StickyZone.displayName = 'StickyZone'
